// extracted by mini-css-extract-plugin
export default {"userLayout":"userLayout_userLayout__sSrm7"};